module.exports = __webpack_public_path__ + "img/pim.cd78a242.svg";